/**
 * DeviceData 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'
import type { DeviceInfo } from './device_info'

/**
 * DeviceData
 */
export interface DeviceData {
  /** 设备ID */
  id?: string
  /** 设备信息 */
  info?: DeviceInfo
}

/**
 * DeviceData Schema
 */
export const DeviceDataSchema: SchemaDefinition = {
  properties: {
    id: {
      description: '设备ID',
      format: 'string',
      type: 'string',
      label: '设备ID',
    },
    info: {
      $ref: 'DeviceInfo',
      description: '设备信息',
      label: '设备信息',
    },
  },
  type: 'object',
}
